import { render, staticRenderFns } from "./MeinServiceAnmelden.vue?vue&type=template&id=31eccfb5&scoped=true&"
import script from "./MeinServiceAnmelden.vue?vue&type=script&lang=js&"
export * from "./MeinServiceAnmelden.vue?vue&type=script&lang=js&"
import style0 from "./MeinServiceAnmelden.vue?vue&type=style&index=0&id=31eccfb5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31eccfb5",
  null
  
)

export default component.exports